import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import MapPicker from 'react-google-map-picker'
const DefaultZoom = 10;

function MapaPickerComponent(props) {

    const [zoom, setZoom] = useState(10);
    const defaultLocation = props.defaultLocation
    const location = props.ubicacion

    function handleChangeLocation(lat, lng) {
        props.setLocation({ lat: Number(lat), lng: Number(lng) });

    }

    function handleChangeZoom(newZoom) {
        setZoom(newZoom);
    }

    function handleResetLocation() {
        props.setDefaultLocation({ ...defaultLocation });
        setZoom(10);
    }

    return (
        <div>
            <MapPicker defaultLocation={location}
                zoom={zoom}
                mapTypeId="roadmap"
                style={{ height: '700px' }}
                onChangeLocation={handleChangeLocation}
                onChangeZoom={handleChangeZoom}
                apiKey='AIzaSyA28kEurjGjL3LxCAxRtMuByqrh7sud2VM' />
            <br />
        </div>
    );
};


export default withRouter(MapaPickerComponent)
